import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { WalletConnectionModalComponent } from "../../shared/wallet-connection-modal/wallet-connection-modal.component";
import { WalletService } from '../../services/wallet.service';
import { ModalService } from '../../services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { WalletAddressFormatPipe } from "../pipes/wallet-address-format.pipe";
import { SupportedNetworks } from '../const/const';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [WalletAddressFormatPipe],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.css'
})
export class NavBarComponent implements OnInit {

  isConnected: boolean = false;
    walletAddress: string = '';
    networkName: string = '';
  
    constructor(
      private walletService: WalletService,
      private modalService: ModalService,
      private cdr: ChangeDetectorRef,
      private readonly toastr: ToastrService
    ) { }
  
  
    /**
     * Initializes the component and subscribes to account changes.
     *
     * This method is part of the Angular `OnInit` lifecycle hook and is called
     * automatically when the component is initialized. It subscribes to the
     * `account$` observable from the `WalletService` to listen for changes in
     * the wallet account. When the account changes, it updates the component's
     * state, including the connection status, wallet address, and network name.
     *
     * The method also manually triggers change detection using `ChangeDetectorRef`
     * to ensure that the UI reflects the latest state changes.
     */
    ngOnInit(): void {
      this.walletService.account$.subscribe((account) => {
        console.log('account observable', account);
        this.isConnected = !!account?.isConnected;
        this.walletAddress = account?.address || '';
        this.networkName = account?.chainId !== undefined ? this.getNetworkName(account.chainId) : '';
        console.log('chainId', this.networkName);
        this.cdr.detectChanges(); // Manually trigger change detection
      });
  
      console.log('---', this.isConnected, this.networkName, this.walletAddress);
    }
  
  
     /**
     * Retrieves the network name based on the chain ID.
     *
     * This helper method takes a `chainId` as input and returns the corresponding
     * network name. It uses a predefined mapping of chain IDs to network names.
     * If the chain ID is not recognized, it returns 'Unsupported Network'.
     *
     * @param chainId - The chain ID for which to retrieve the network name.
     * @returns The network name corresponding to the given chain ID.
     */
     private getNetworkName(chainId: number): string {
      const networks: { [key: number]: string } = SupportedNetworks
      return networks[chainId] || 'Unsupported Network';
    }
  
     /**
     * Disconnects the wallet from MetaMask.
     *
     * This method calls the `disconnectWallet` method from the `WalletService`
     * to initiate the disconnection process for the currently connected wallet.
     * It is typically triggered by a user action, such as clicking a disconnect
     * button in the UI.
     */
     disconnectMetamask() {
      this.walletService.disconnectWallet();
    }
  
    /**
     * Opens a modal dialog.
     *
     * This method uses the `ModalService` to open a modal dialog with the ID
     * 'crypto-modal'. It is typically triggered by a user action, such as
     * clicking a button to open the modal.
     */
    openModal(): void {
      this.modalService.open('crypto-modal');
    }

    /**
     * Copies the given address to the clipboard.
     *
     * This method creates a hidden textarea with the given address as its value,
     * selects the text, and calls the `execCommand('copy')` method to copy the
     * address to the clipboard. It then removes the textarea from the DOM and
     * shows a toast message indicating that the address has been copied
     * successfully.
     *
     * @param address - The address to copy to the clipboard.
     */
    copyAddress(address: string): void {
      const textArea = document.createElement('textarea');
      textArea.value = address;
      document.body.appendChild(textArea)
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      this.toastr.success('Address copied successfully');
    }

}
